import { useMutation } from "@tanstack/react-query";
import { saveBloomreachMappings } from "../../api/bBloomreachApi";

export const useSaveBloomreachMappings = () => {
  return useMutation({
    mutationKey: ["save-bloomreach-mappings"],
    mutationFn: (data) => saveBloomreachMappings(data),
  });
};
